const INITIAL_STATE = {
    campanha: {},
    campanhas: [],
    uploadedFiles: [],
    existingFiles: [],
    loading: false,
    veiculosPublicidadeAtivos: [],
}

export default function Publicidade(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'CAMPANHA_LOADING' :
            return { ...state, loading: action.payload }
        case 'CAMPANHAS_FETCHED':
            return { ...state, campanhas: action.payload }
        case 'CAMPANHA_FETCHED':
            return { ...state, campanha: action.payload }
        case 'CAMPANHA_SAVED':
            return { ...state, campanha: {} }
        case 'EXISTING_FILES':
            return { ...state, existingFiles: action.payload }
        case 'UPLOADED_FILES':
            return { ...state, uploadedFiles: [...action.payload] }
        case 'UPDATE_UPLOADED_FILES':
            const data = action.payload;
            const { uploadedFiles } = state;
            const uploadingFiles = uploadedFiles.map(file => {
                return data.idTemp === file.idTemp ? { ...file, ...data } : file;
            })
            return { ...state, uploadedFiles: uploadingFiles }
        case 'DELETE_UPLOADED_FILE':
            const id = action.payload;
            const files = state.uploadedFiles.filter(file => file.id !== id);
            return { ...state, uploadedFiles: files }
        case 'VEICULOS_PUBLICIDADE_ATIVOS_FETCHED':
            return { ...state, veiculosPublicidadeAtivos: action.payload };
        default:
            return state;
    }
}